import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'

import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
import './styles/index.scss'
import { formatDateTime } from './utils/time'

Vue.use(ElementUI, { size: 'medium' })
Vue.config.productionTip = false
Vue.prototype.$formatDateTime = formatDateTime

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
